import React, { useState, useEffect } from "react";
import { Row, Col } from "antd";

// import HomeDevice from "../../components/deviceHome/homeDevice";
import HomeDevice from "../../components/deviceHomeP/homeDevice";

export default function DeviceHome(prop) {
  return (
    <div>
      <Row>
        <Col span={24}><HomeDevice /></Col>
      </Row>
    </div>
  );
}
